export default "__VITE_ASSET__LN9Ql7Dm__"